import {UrlListItem} from '../../Types'
import {ListUtility} from '../../../Utils/ListUtility'

export interface AdminBucketInfo {
  id: number
  bucketKey: string
  name: string
  logoImgUrl?: string
}

export interface AdminBucketInfoJSON {
  id: number
  bucketKey: string
  name: string
  urlList?: UrlListItem[]
}

export class AdminBucketInfoDTO implements AdminBucketInfo {
  id: number
  bucketKey: string
  name: string
  logoImgUrl?: string

  constructor(id: number, bucketKey: string, name: string, logoImgUrl?: string) {
    this.id = id
    this.bucketKey = bucketKey
    this.name = name
    this.logoImgUrl = logoImgUrl
  }

  static fromJSON(jsonObject: AdminBucketInfoJSON): AdminBucketInfoDTO {
    const filteredLogoImg = ListUtility.findOne<UrlListItem>(
      jsonObject.urlList || [],
      item => item.type === 'logoImg',
    )
    const logoImgUrl = filteredLogoImg?.url

    return new AdminBucketInfoDTO(
      jsonObject.id,
      jsonObject.bucketKey,
      jsonObject.name,
      logoImgUrl,
    )
  }
}
